export default (fieldData, versionNumber) => ({
  ...fieldData,
  document: {
    ...fieldData.document,
    data: {
      ...fieldData.document.data,
      version: {
        number: versionNumber,
        updated: true,
      },
    },
  },
});
